import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './authLayout.css';
import { getProfile } from '../services/apiService';
import Skeleton from 'react-loading-skeleton';
import LangIcon from '../components/icons/LangIcon';
import HomeIcon from '../components/icons/HomeIcon';
import GlobeIcon from '../components/icons/GlobeIcon';
import LinkedinIcon from '../components/icons/LinkedinIcon';
import PersonIcon from '../components/icons/PersonIcon';
import PaperPlaneIcon from '../components/icons/PaperPlaneIcon';
import ChatIcon from '../components/icons/ChatIcon';

const AuthLayout = ({  handleLogout, i18n, changeLanguage }) => {
  const { t } = useTranslation();

  const location = useLocation();
  
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState(null);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    getProfile(setLoading, setProfile, setError);
  }, []);

  const navItems = [
    { key: 'dashboard', to: `/${i18n.language}/dashboard`, label: t('dashboard'), Icon: HomeIcon },
    { key: 'organizations', to: `/${i18n.language}/organizations`, label: t('organizations'), Icon: GlobeIcon },
    { key: 'linkedinAccounts', to: `/${i18n.language}/linkedin-accounts`, label: t('linkedinAccounts'), Icon: LinkedinIcon },
    { key: 'leads', to: `/${i18n.language}/leads`, label: t('leads'), Icon: PersonIcon },
    { key: 'campaigns', to: `/${i18n.language}/campaigns`, label: t('campaigns'), Icon: PaperPlaneIcon },
    { key: 'messages', to: `/${i18n.language}/messages`, label: t('messages'), Icon: ChatIcon },
  ];

  const tooltipClassName = 'hidden group-hover:block pointer-events-none absolute start-full ms-[20px] top-1/2 -translate-y-1/2 whitespace-nowrap bg-tprimary text-white text-[13px] font-[500] px-[14px] py-[8px] rounded-md z-[100] rubik shadow-lg';

  return (
    <div className='dashboard-layout'>
      
      <div className='flex flex-nowrap min-h-[100vh]'>
        <div className='w-[74px] dashboard-sidebar bg-tprimary flex flex-col items-center px-[9px]'>

          <div className='w-full pt-[9px] pb-[24px]'>
            <div className='w-full h-[56px] bg-white rounded-none flex items-center justify-center shadow-[0px_4px_10px_0px_rgba(10,24,38,0.15)]'>
              <img src="/assets/images/logo.svg" alt="ABMFY" className='w-[42px] h-[42px] object-contain' />
            </div>
          </div>

          <nav className='w-full'>
            <ul className='m-0 flex flex-col items-center gap-1'>
              {navItems.map(({ key, to, label, Icon }) => {
                const isActive = location.pathname === to;
                return (
                  <li key={key} className='relative group w-[48px] h-[48px]'>
                    <Link to={to} className={`flex items-center justify-center w-full h-[48px] rounded-md transition-all ${isActive ? 'bg-white/15' : 'hover:bg-white/10'}`}>
                      <Icon className='w-[22px] h-[22px]' />
                    </Link>
                    <span className={tooltipClassName}>{label}</span>
                  </li>
                );
              })}
            </ul>
          </nav>

          <div className='mt-auto mb-[24px] relative group w-full'>

            <button type='button' onClick={() => changeLanguage(i18n.language === 'ar' ? 'en' : 'ar')} className='flex items-center justify-center w-full h-[56px] rounded-md hover:bg-white/10 transition-all'>
              <LangIcon color='#fff' width='22' height='22' />
            </button>
            <span className={tooltipClassName}>{i18n.language === 'ar' ? 'Change to English' : 'تغيير الي اللغه العربية'}</span>
          </div>

        </div>
        <div className='w-[calc(100%-74px)] dashboard-content p-[37px] relative h-[100vh] overflow-y-auto'>

          <div className='absolute top-[20px] end-[37px]'>
              <div className=' cursor-pointer text-tprimary text-[16px] font-[500] h-[20px] leading-[20px] my-2 select-none'>
                {loading && !profile ? <Skeleton baseColor='#885023' className='max-w-[200px] h-[20px]' /> 
                : <div onClick={()=>setIsDropdownOpen(!isDropdownOpen)}>{profile?.email}
                <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg" className='inline-block ms-[10px] h-[20px] align-top'>
                  <path d="M6.40686 2.82843L3.57843 5.65685L0.750006 2.82843" stroke="#0BB885" strokeWidth="1.5" strokeLinecap="round"/>
                </svg></div>}
              </div>

              {/* Dropdown */}
              {isDropdownOpen && <div className='absolute top-[57px] end-[37px] bg-[#FAFAFA] rounded-[12px] w-[212px] z-[100] px-[18px] py-[23px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.07)]'>
                <span className='absolute top-[-5px] end-[5px] w-[36px] h-[39px] block bg-[#FAFAFA] rotate-[45deg]'></span>
                <ul className='relative !text-start'>
                  <li className='leading-[23px] text-taction cursor-pointer' onClick={handleLogout}><span className=''>{t('logout')}</span></li>
                </ul>
              </div>}
          </div>


          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
